import { useState } from "react";
import { motion } from "framer-motion";
import { MaskLines, Overline } from "./Reveal";

const stack = {
  ai: ["OpenAI", "Anthropic Claude", "Google Gemini", "Llama", "LangChain", "LlamaIndex", "Hugging Face", "PyTorch", "scikit-learn"],
  data: ["Python", "SQL", "Spark", "dbt", "Airflow", "Snowflake", "Databricks", "Postgres", "Pinecone", "Power BI"],
  infra: ["AWS", "Azure", "Google Cloud", "Docker", "Kubernetes", "MLflow", "FastAPI", "React"],
};
const tabs = [["all", "All"], ["ai", "AI & LLM"], ["data", "Data"], ["infra", "Cloud & MLOps"]];
const colors = ["hover:bg-violet", "hover:bg-emerald", "hover:bg-amber", "hover:bg-coral"];

export const Stack = () => {
  const [tab, setTab] = useState("all");
  const items = tab === "all" ? Object.values(stack).flat() : stack[tab];
  return (
    <section id="tech" data-testid="tech-stack-section" className="border-y border-ink/10 bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <div className="mb-12 flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div>
            <Overline color="bg-emerald">04 — Stack</Overline>
            <h2 className="font-display text-5xl leading-[1] tracking-tight text-ink sm:text-6xl">
              <MaskLines inView lines={["Tools we", <em className="text-emerald">trust in production.</em>]} />
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {tabs.map(([k, l]) => (
              <button key={k} data-testid={`tech-tab-${k}`} onClick={() => setTab(k)} className={`relative rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${tab === k ? "text-[#FBF9F5]" : "text-ink hover:bg-ink/5"}`}>
                {tab === k && <motion.span layoutId="tabpill" className="absolute inset-0 rounded-full bg-ink" transition={{ type: "spring", stiffness: 380, damping: 30 }} />}
                <span className="relative">{l}</span>
              </button>
            ))}
          </div>
        </div>
        <motion.div layout className="flex flex-wrap gap-3" data-testid="tech-stack-list">
          {items.map((t, i) => (
            <motion.span
              layout
              key={t}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: i * 0.02 }}
              className={`cursor-default rounded-full border border-ink/15 bg-[#FBF9F5] px-5 py-3 text-base font-medium text-ink transition-colors duration-300 hover:text-white ${colors[i % 4]} sm:text-lg`}
            >
              {t}
            </motion.span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
